// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-input[data-v-d609d72c] {\n  border: #a94442;\n}\n.error-message[data-v-d609d72c] {\n  margin: 0 0 1% 0;\n  color: #a94442;\n  font-size: 12px;\n}\n.error-label[data-v-d609d72c] {\n  color: #a94442;\n}", ""]);
// Exports
module.exports = exports;
